import { Helmet } from 'react-helmet-async';

export default function TermsPage() {
  return (
    <>
      <Helmet>
        <title>Terms of Use | MrJoe.Pro Service Agreement & Conditions</title>
        <meta name="description" content="Read MrJoe.Pro's Terms of Use by Buildmetric LLC. Understand your rights and responsibilities when using our contractor software platform. Last updated February 15, 2025." />
        <meta name="keywords" content="MrJoe.Pro terms of use, service agreement, terms of service, Buildmetric terms, contractor software terms" />
        <link rel="canonical" href="https://mrjoe.pro/pub/terms_of_use" />
        
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://mrjoe.pro/pub/terms_of_use" />
        <meta property="og:title" content="Terms of Use | MrJoe.Pro" />
        <meta property="og:description" content="Review the terms and conditions for using MrJoe.Pro contractor software services." />
        
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Terms of Use | MrJoe.Pro" />
        <meta name="twitter:description" content="Review the terms and conditions for using MrJoe.Pro contractor software services." />
      </Helmet>

      <section className="page-padding">
        <div className="container-safe">
          <div className="mx-auto max-w-[1008px] text-lg tracking-tight">
            <h1 className="page-heading">Terms of Use for MrJoe.pro</h1>

            {/* Updated */}
            <div className="mt-7">
              <p className="text-xl font-medium">Last Updated: February 15, 2025</p>
              <p className="mt-2">
                MrJoe.pro is owned and operated by Buildmetric LLC, a company registered in the state
                of Florida ("Company," "we," "us," or "our"). These Terms of Service ("Terms")
                constitute a legally binding agreement between you and the Company regarding your
                access to and use of MrJoe.pro's website, services, and applications (collectively,
                the "Services").
              </p>
            </div>

            <article className="mt-10">
              {/* 1 */}
              <h2 className="text-xl font-medium">1. Introduction</h2>
              <p className="mt-2">
                Welcome to MrJoe.pro. These Terms of Service govern your access to and use of
                MrJoe.pro's website, services, and applications. By using our Services, you agree to
                be bound by these Terms. If you disagree with any part of these Terms, you may not
                access our Services.
              </p>

              {/* 2 */}
              <h2 className="mt-6 text-xl font-medium">2. Definitions</h2>
              <ul className="list-disc pl-6">
                <li>Platform refers to MrJoe.pro website and associated services.</li>
                <li>User, you, and your refer to individuals and businesses using our Services.</li>
                <li>Company, we, us, and our refer to MrJoe.pro.</li>
                <li>
                  Content refers to all information, data, text, photographs, and other materials
                  uploaded or created through our Services.
                </li>
              </ul>

              {/* 3 */}
              <h2 className="mt-6 text-xl font-medium">3. Account Registration and Authority</h2>

              <h3 className="mt-2">3.1. Corporate Entity Registration</h3>
              <p className="mt-2">
                If you are registering for an account or using the Service on behalf of an entity,
                organization, or company ("Corporate Entity"), you:
              </p>
              <ul className="list-disc pl-6">
                <li>Agree to these Terms on behalf of that Corporate Entity;</li>
                <li>
                  Represent and warrant that you have the authority to bind that Corporate Entity to
                  these Terms;
                </li>
                <li>
                  Acknowledge that the terms "Customer," "you," and "your" will refer to that
                  Corporate Entity;
                </li>
                <li>Accept responsibility for all actions taken under your account.</li>
              </ul>

              <h3 className="mt-2">3.2. Customer Communications and Consent</h3>
              <p className="mt-2">
                By registering your company and creating an account with MrJoe.pro, you expressly:
              </p>
              <ul className="list-disc pl-6">
                <li>
                  Represent and warrant that the entities you are serving have consented to receive
                  messages in different digital formats;
                </li>
                <li>
                  Confirm that your business relationship includes acceptance of digital
                  communications;
                </li>
                <li>Accept responsibility for maintaining records of customer consent;</li>
                <li>Must comply with all applicable laws regarding customer communications.</li>
              </ul>

              {/* 4 */}
              <h2 className="mt-6 text-xl font-medium">4. Service Description and Restrictions</h2>

              <h3 className="mt-2">4.1. Service Overview</h3>
              <p className="mt-2">
                MrJoe.pro provides a digital platform and related services for contractors to manage
                their business operations and communicate with their customers. The specific features
                and functionality of the Service may be modified from time to time at our discretion.
              </p>

              <h3 className="mt-2">4.2. Service Access and Competitors</h3>
              <ul className="list-disc pl-6">
                <li>MrJoe.pro's direct competitors are prohibited from accessing the Service;</li>
                <li>You may not access the Service to build competing products or services;</li>
                <li>
                  You may not reverse engineer, decompile, or attempt to discover the source code of
                  the Service.
                </li>
              </ul>

              {/* 5. Governing Law and Jurisdiction */}
              <h2 className="mt-6 text-xl font-medium">5. Governing Law and Jurisdiction</h2>

              <h3 className="mt-2">5.1. Governing Law</h3>
              <p className="mt-2">These Terms shall be governed by:</p>
              <ul className="list-disc pl-6">
                <li>The laws of the State of Florida;</li>
                <li>Without regard to conflicts of law principles.</li>
              </ul>

              <h3 className="mt-2">5.2. Dispute Resolution</h3>
              <p className="mt-2">Any disputes shall be resolved in:</p>
              <ul className="list-disc pl-6">
                <li>The state or federal courts located within the State of Florida; and/or</li>
                <li>
                  Through binding arbitration in accordance with applicable Florida law and
                  arbitration rules, when required by law.
                </li>
              </ul>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}